import { Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import FarmacyProfilePage from "./pages/ProfilePage";
import EditarPerfil from "./pages/editProfile";
import CrearQR from "./pages/CreateQr";
import ForgotPass from "./pages/ChangePass/ForgotPass"
import NewPass from "./pages/ChangePass/NewPass"


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/preview" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/newPass" element={<LoginPage />} />
      <Route path="/farmacia/:cuit" element={<FarmacyProfilePage />} />
      <Route path="/editar-perfil" element={<EditarPerfil />} />
      <Route path="/CreateQr" element={<CrearQR/>} />
      <Route path="/ForgotPass" element={<ForgotPass/>} />
      <Route path="/resetPassword" element={<NewPass/>} />
    </Routes>
  );
};

export default AppRoutes;
